import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver, EventEmitter,
  Input, Output, ViewChild,
  ViewEncapsulation
} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {CcBaseComponent} from "../../../../crystal-elements/cc-base.component";
import {ReportTaskService} from "../../../../services/archive/report-task.service";
import {CrystalClearFrontUrl} from "../../../../shared/pages/crystal-clear-front-url";
import {CcTableComponent} from "../../../../crystal-elements/table/cc-table.component";
import {OverlayPanelModule} from "primeng/overlaypanel/overlaypanel";
import {OverlayPanel} from "primeng/overlaypanel";
import {Table} from "primeng/table";

@Component({
  selector: 'app-archive-tasks-button',
  templateUrl: './report-tasks-button.component.html',
  styleUrls: ['./report-tasks-button.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReportTasksButtonComponent extends CcBaseComponent {

  @Input()
  buttonTitle: string = 'page_title.archive.tasks';
  @Input()
  transPartKey: string = 'report-tasks';
  CrystalClearFrontUrl = CrystalClearFrontUrl;

  @Input()
  origins: string[];
  inProgressCount: number = 0;
  detailDialogVisible: boolean = false;
  @ViewChild('op')
  op: OverlayPanel;

  constructor(cdref: ChangeDetectorRef,
              componentFactoryResolver: ComponentFactoryResolver,
              messageService: MessageService,
              protected reportTaskService: ReportTaskService,
              translateService: TranslateService) {
    super(cdref, messageService, translateService);

  }

  updateOp($event: boolean) {
    setTimeout(() => {
      this.op.unbindDocumentClickListener();
      this.op.bindDocumentClickListener();
    });
  }
}
